import styled from 'styled-components';
import { InfoLayoutProps } from '../../types';

export const TextBookContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TextBookInfoContainer = styled.div`
  width: 100%;
  display: flex;

  column-gap: 10px;
  row-gap: 20px;
  justify-content: flex-start;
  align-items: flex-start;

  padding-top: 40px;
  flex-wrap: wrap;
`;

export const TextBookBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1 0 32%;
  gap: 5px;

  .text {
    font-size: 14px;
    line-height: 15px;
  }

  .layout {
    color: #7594b9;
  }
`;

export const SignedElementsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 5px;
  flex-direction: column;

  .text {
    color: #7594b9;
    font-size: 12px;
    font-weight: 400;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    gap: 5px;

    svg {
      height: 18px;
      font-size: 16px;
    }
  }
`;

export const InfoLayout = styled.div<InfoLayoutProps>`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: ${(props) => (props.direction ? 'center' : 'flex-start')};
  flex-direction: ${(props) => props.direction || 'column'};
  gap: ${(props) => props.direction && '10px'};

  font-size: ${(props) => (props.size ? `${props.size}px` : '16px')};
  color: ${(props) => (props.color ? props.color : 'rgba(56, 72, 91, 0.8)')};
  font-weight: ${(props) => (props.weight ? props.weight : 400)};

  .dark {
    color: black;
  }

  .link {
    text-decoration: underline;
    color: rgba(56, 72, 91, 0.8);
    font-size: 15px;
  }
`;
